import React from "react";

const StatusEventsControl = ({ open, enabled, onChange }) => (
            open ? <section id="status-events-panel" className="graph-page__card" aria-labelledby="status-events-heading">
                <div className="graph-page__card-head graph-page__card-head--split"><div>
                <h2 id="status-events-heading">Connection status</h2>
                <p>When enabled, an additional request checks connection events and adds gaps to the chart during outages.</p>
                </div><label className="graph-page__check" htmlFor="graph-status-events"><input id="graph-status-events" type="checkbox" role="switch" checked={enabled} onChange={(event) => onChange(event.target.checked)} />Check status</label></div>
            </section> : null
);

export default StatusEventsControl;
